<template>
    <div class="cc-recap">
        <div class="cc-recap__header">
            <div class="cc-title cc-title--section">{{ translations['Cart contents'] }}</div>
        </div>
        <div class="cc-recap__main">
            <products/>
            <selected-carrier/>
            <selected-payment/>
            <free-delivery/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Products from "./Products";
    import SelectedCarrier from "./SelectedCarrier";
    import SelectedPayment from "./SelectedPayment";
    import FreeDelivery from "./FreeDelivery";

    export default {
        components: {
            Products,
            SelectedCarrier,
            SelectedPayment,
            FreeDelivery,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/recap";
</style>
